export const RegistrationStatus = Object.freeze({
  ACTIVE: 'Active',
  COMPLETE: 'Complete',
  PENDING: 'Pending',
  IN_PROGRESS: 'In Progress',
  AWAITING_VERIFICATION: 'Awaiting Verification',
  DELETED: 'Deleted',
  TERMINATED: 'Terminated',
})
